import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Archives from "../pages/archives/page";
import ArticleDetail from "../pages/archives/detail/page";
import Faq from "../pages/faq/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/archives",
    element: <Archives />,
  },
  {
    path: "/archives/:slug",
    element: <ArticleDetail />,
  },
  {
    path: "/faq",
    element: <Faq />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;